import React from 'react';

const CLUE_RAIDER_URL = 'https://clueraider.com/';

const ClueRaiderBanner: React.FC = () => (
  <div className="px-2 sm:px-4">
    <div className="w-full md:max-w-xl mx-auto">
    <a
      href={CLUE_RAIDER_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="flex w-full items-stretch overflow-hidden transition-opacity hover:opacity-95 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white/50 rounded-xl"
    style={{
      backgroundColor: '#1e293b',
      color: '#E8D5B7',
      fontFamily: "'Oswald', sans-serif",
      letterSpacing: '0.05em',
      minHeight: '72px',
    }}
  >
    <div className="flex flex-1 items-center justify-center px-4 py-3 text-center">
      <span className="text-sm sm:text-base">
        Love logic puzzles? Play our new daily puzzle: <strong>Clue Raider</strong> — raid ancient chambers, decode clues, find the treasure.
        <span className="ml-1 inline-block">→</span>
      </span>
    </div>
  </a>
  </div>
  </div>
);

export default ClueRaiderBanner;
